module.exports = "/_next/static/images/yatoo-vertical.nc-6001cac5ca57ab3f9b4733a5b4589506.svg";